import type { FC } from 'react';

interface Props {
  className?: string;
}

const PatioBalconyIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 18h18v3H3z" />
    </svg>
  );
};

export default PatioBalconyIcon;
